import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  CandidateTechnicalInfoBuilder,
  SaveCandidateTechnicalInfoInput,
  SaveCandidateTechnicalInfoOutput,
} from '../candidate-technical-info.types';

export const saveCandidateTechnicalInfo = (
  builder: CandidateTechnicalInfoBuilder
) =>
  builder.mutation<
    SaveCandidateTechnicalInfoOutput,
    SaveCandidateTechnicalInfoInput
  >({
    query: ({ data }) => {
      const url = data?.Id
        ? `/candidate-technical-information/${data?.Id}`
        : `/candidate-technical-information/add`;
      const method = data?.Id ? 'PUT' : 'POST';
      return {
        url,
        method,
        body: {
          ...data,
          Id: data?.Id,
          AvailableSpace: data?.AvailableSpace!,
          CPUModel: data?.CPUModel,
          OperatingSystem: data?.OperatingSystem,
          RAM: parseInt(data?.RAM!, 10),
          Storage: data?.Storage!,
        },
      };
    },
    invalidatesTags: [
      {
        type: 'CandidateTechnicalInfo',
        id: 'LIST',
      },
      'Score',
    ],
    transformErrorResponse: (error, meta, { lang }) => {
      errorHandler(
        '[setTechnicalInformation]',
        lang === 'es' ? ErrorMessageEs.InfoFail : ErrorMessageEn.InfoFail,
        error,
        true
      );
    },
  });
